/* eslint-disable no-param-reassign */
import $services from "@/Services";

export default (vue) => {
  vue.prototype.$services = $services;
};
